import { Location } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, HostListener, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { APIService } from 'src/app/services/APIService';
import { AuthService } from 'src/app/services/auth.service';
import { LocalUtilService } from 'src/app/services/local-util.service';
import { MessagesService } from 'src/app/services/messages.service';
import { DomSanitizer } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import { AreaGeograficaItem, AuctionBetSetupItem, AuctionItem, AuctionLotFavElem, AuctionLotItem, AuctionLotTimerItem, AuctionSetupItem, CentroSelezioneItem, GetAuctionLotsResponse, GetAuctionLotUserFavouriteResponse, GetSelectionCenterListResponse, HeaderDetail, MaterialTypeItem, MatRule, SchedaTecnicaItem, SliderValue } from 'src/app/models/dataModels';
import { AuctionService } from 'src/app/services/auction.service';
import { CommonService } from 'src/app/services/common.service';
import { ConstantsModule } from 'src/app/services/constants.module';
import { DxDataGridComponent } from 'devextreme-angular';
import { ConfirmComponent } from 'src/app/commons/components/confirm/confirm.component';
import { OrganizationService } from 'src/app/services/organization.service';
import { PopupComponent } from 'src/app/commons/components/popup/popup.component';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { trigger, transition, style, animate, state, keyframes } from '@angular/animations';
import { PageVisibilityService } from 'src/app/services/PageVisibility.service';
import { WindowFocusService } from 'src/app/services/WindowFocus.service';
import { WindowStateService } from 'src/app/services/window-state.service';
import { TimerComponent } from 'src/app/commons/components/timer/timer.component';

@Component({
  selector: 'app-aste-in-corso',
  templateUrl: './aste-in-corso.component.html',
  styleUrls: ['./aste-in-corso.component.css'],
  encapsulation: ViewEncapsulation.None, // Add this line,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AsteInCorsoComponent extends APIService implements OnInit, OnDestroy {

  @ViewChild("dataGridLots", { static: false }) dataGridLots: DxDataGridComponent;

  @ViewChildren('selectElement') selectElements!: QueryList<ElementRef>;

  @ViewChildren(TimerComponent) timerComponents: QueryList<TimerComponent>;

  constructor(public localService: LocalUtilService,
    public authService: AuthService,
    public auctionService: AuctionService,
    public commonService: CommonService,
    private modalService: NgbModal,
    private messageService: MessagesService,
    private organizationService: OrganizationService,
    private sanitizer: DomSanitizer,
    public httpClient: HttpClient,
    location: Location,
    router: Router,
    private route: ActivatedRoute,
    private translate: TranslateService,
    public pageVisibilityService: PageVisibilityService,
    public windowFocusService: WindowFocusService,
    translateService: TranslateService,
    private windowStateService: WindowStateService,
    private cdRef: ChangeDetectorRef) {
    super(localService, location, router, translateService);


    let windowFocusCheckService = this.windowStateService.isWindowActive$.subscribe((active) => {
      if (active && !this.isActive) {
        let actualUrl = this.getRouterLinkAuctionList(this.codiceAsta);
        this.router.navigateByUrl(this.router.url);
      }
      this.isActive = active;
    });
    this.subscriptions.push(windowFocusCheckService);

  }

  trackByFn(index, item) {
    try {
      return `${item.codiceLotto}-${item.prezzoUltimoRilancio}-${item.numeroRilanci}`;
    } catch (err) {
      console.log(item);
      return null;
    }
  }

  auctionReloadLotsMonitor: Subscription;

  area_list: AreaGeograficaItem[] = [];
  material_list: MaterialTypeItem[] = [];
  bet_list: AuctionBetSetupItem[] = [];

  codiceAsta: string;
  auctionDetail: AuctionItem;
  auctionLots: AuctionLotItem[] = [];
  auctionLotsFull: AuctionLotItem[] = [];
  favouriteLots: AuctionLotFavElem[] = [];
  scheda_list: SchedaTecnicaItem[] = [];
  auction_configuration: AuctionSetupItem;

  minimumBetSlot: number;
  toggleFilterFavourite: boolean = false;
  betSlotLotto = new Map();

  //reload button vars
  reloadEnabled: boolean = true;

  //refresh 15 sec var
  secondsToRefresh: number;

  isTaglioRilancioLibero: boolean = false;

  //search header
  searchLotText: string;

  //navbar sticky
  navbarfixed: boolean = false;

  //headerDetail
  headerDetail: HeaderDetail = new HeaderDetail();
  scrollPositionY: number = 0;

  enabled_materials: string[] = ['PET-Azzurrato', 'PET-Colorato', 'PET-Trasparente', 'PET-Misto'];
  enabledDdlStyle: boolean = false;
  refreshLotMillis: string = ConstantsModule.AUC_REFRESH_LOT_MILLIS.toString();
  private subscriptions: Subscription[] = [];
  private isActive = true;

  
  ngOnInit(): void {
    this.codiceAsta = this.route.snapshot.paramMap.get('codiceAsta');
    this.localUtil.activeAuctionCode = this.codiceAsta;
    this.bindRefreshLotsForRefreshErr();
    this.loadAreaGeo();
    this.loadMaterialType();
    this.loadSchedaTecnicaList();
    this.loadAuctionConfiguration();

    if (this.codiceAsta != undefined) {
      this.setHeaderSticky();
      this.getAuctionDetailWithLots('ngOnInit');
      this.initHeaderMonitor();
      this.initAuctionHeader();
      this.setNullHeaderTimers();
    }
    this.isActive = true;
    this.setFavFilter();
  }

  showActiveAuctionBanner(event) {
    try {
      setTimeout(() => {
        this.cdRef.detectChanges();
      }, 0);
    } catch (err) {
      console.log(err);
    }
  }

  setFavFilter() {
    try {
      const previous_filter = this.localUtil.getSessionProp('fav_filter');
      if (previous_filter !== undefined && previous_filter === 'true') {
        this.toggleFilterFavourite = true;
      } else {
        this.toggleFilterFavourite = false;
      }
    } catch (error) {
      console.error('Error while setting favorite filter:', error);
      this.toggleFilterFavourite = false;
    }
  }

  handleKeyDown(event: KeyboardEvent): void {
    try {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault(); // Prevents default scroll on space
      }
    } catch (error) {
      console.error('Error handling key down event:', error);
    }
  }

  /*subscribePageVisibility() {
    const pageVisibilityService = this.pageVisibilityService.visibilityChange$.subscribe(isVisible => {
      if (isVisible) {
        setTimeout(() => this.getAuctionDetailWithLots('subscribePageVisibility'),0);
      }
    });
    this.subscriptions.push(pageVisibilityService);
  }

  subscribeChromeFocus() {
    const windowFocusService = this.windowFocusService.focusChange$.subscribe(isFocused => {
        if (isFocused) {
          setTimeout(() => this.getAuctionDetailWithLots('subscribeChromeFocus'),0);
        }
      });
      this.subscriptions.push(windowFocusService);
  }*/

  bindRefreshLotsForRefreshErr() {
    try {
      const refreshAuctionLotsService = this.refreshAuctionLots.subscribe(() => {
        setTimeout(() => this.getAuctionDetailWithLots('bindRefreshLotsForRefreshErr'), 0);
      });
      this.subscriptions.push(refreshAuctionLotsService);
    } catch (err) {
      //
    }
  }

  getCodiceAsta() {
    return this.route.snapshot.paramMap.get('codiceAsta');
  }

  ngOnDestroy() {
    try {
      this.subscriptions.forEach(sub => {
        sub.unsubscribe()
      });
    } catch (err) {
      //
    }
    try {
      if (this.refreshTimerId) {
        clearTimeout(this.refreshTimerId);
      }
    } catch (err) {
      //      
    }
  }


  initAuctionHeader() {
    setTimeout(() => {
      try {
        if (this.headerDetail == undefined) {
          this.headerDetail = new HeaderDetail();
        }

        const cardsLotsList = document.getElementById("cards-lots-list");
        if (cardsLotsList) {
          const sticky = cardsLotsList.offsetTop;
          const tableHeader = document.getElementById("cards-lots-list-header") as HTMLElement;

          const scrollPosition = window.pageYOffset;
          const offset_var = 145;

          if (scrollPosition + offset_var > sticky) {
            this.navbarfixed = true;
            this.headerDetail.stickyHeader = true;
            this.headerDetail.capacityHeader = true;
          } else {
            this.headerDetail.stickyHeader = false;
            this.headerDetail.capacityHeader = true;
          }
        }

        if (this.codiceAsta == undefined) {
          this.headerDetail.stickyHeader = false;
          this.headerDetail.capacityHeader = false;
        } else {
          this.headerDetail.capacityHeader = this.auctionDetail && this.auctionDetail.tipologiaAsta == ConstantsModule.TIPOLOGIA_ASTA_DEFAULT
            ? true
            : this.headerDetail.capacityHeader;
        }

        this.headerDetail.view = ConstantsModule.AUC_VIEW_LIST;
        this.localUtil.setHeaderMonitor(this.headerDetail);

        if (this.auctionDetail == undefined) this.initAuctionHeader();          
      } catch (error) {
        console.error('Error in initAuctionHeader:', error);
      }
    }, 600);
  }

  setNullHeaderTimers() {
    this.localUtil.setTimers(undefined);
  }

  simulateScroll() {
    window.scrollTo(0, window.scrollY + 1);
    window.scrollTo(0, window.scrollY - 1);
  }

  initHeaderMonitor() {
    try {
      if (this.codiceAsta != undefined && !this.auctionReloadLotsMonitor) {
        this.auctionReloadLotsMonitor = this.localUtil.getAuctionReloadLotsMonitor().subscribe(
          res => {
            try {
              if (res) {
                this.getAuctionDetailWithLots('initHeaderMonitor');
              }
            } catch (innerError) {
              console.error('Error in subscription callback of initHeaderMonitor:', innerError);
            }
          }
        );
        this.subscriptions.push(this.auctionReloadLotsMonitor);
      }
    } catch (error) {
      console.error('Error in initHeaderMonitor:', error);
    }
  }

  getAuctionDetailWithLots(caller, forceReload?) {
    try {
      //console.log('getAuctionDetailWithLots(' + caller + ')');
      if (this.getCodiceAsta() != undefined) {
        if (this.reloadEnabled || (forceReload != undefined && forceReload === true)) {
          this.reloadEnabled = false;
  
          this.localUtil.lotsLoaderCalled();
          this.loadRules();
  
          setTimeout(() => {
            this.enableReloadButton()
          }, 1000);
  
          const getAuctionLotsService = this.auctionService.getAuctionLots(this.codiceAsta, "").subscribe(
            (res: GetAuctionLotsResponse) => {
              this.auctionDetail = res.auctionDetail;
              this.auctionDetail.serverTime = res.serverTime;
  
              if (this.auctionDetail.statoAsta == ConstantsModule.AUCTION_STATUS_CLOSED) {
  
                const modalRef = this.modalService.open(PopupComponent);
                modalRef.componentInstance.titolo = ConstantsModule.INFO_TITLE;
                modalRef.componentInstance.messaggio = this.checkAndReplaceTranslation(this.translate, this.messageService.getLabelFromCode('AUCTION_CLOSED'));
                modalRef.componentInstance.tipo = 'message';
                ConstantsModule.REFRESH_LOTS_ENABLED = false;
                const modalRefService = modalRef.componentInstance.passEntry.subscribe((receivedEntry: any) => {
                  this.router.navigate([ConstantsModule.REF_AZ_ASTE_VINTE_PATH]);
                });
                this.subscriptions.push(modalRefService);
              }
              let lotList: AuctionLotItem[] = res.lotList;
              this.localUtil.setServerTime(res.serverTime);
              this.resetBetSlotList();
              this.setAttributeToLots(lotList, res.serverTime);
              this.disableItemRule2(lotList);
              this.loadFavouriteLots(lotList, true);
              this.getBetSlotList(this.auctionDetail.tipologiaAsta);
              this.auctionLotsFull = lotList;
            },
            this.handleError(true, this.getAuctionDetailWithLots('handleerror'))
          );
          this.subscriptions.push(getAuctionLotsService);
        }
      }
    } catch (err) {
      console.error("Error in getAuctionDetailWithLots:", err);
    }
  }  

  resetBetSlotList() {
    this.betSlotLotto = new Map();
  }

  setAttributeToLots(auctionLots: AuctionLotItem[], serverTime) {
    setTimeout(() => {
      try {
        // console.log('setAttributeToLots');
        if (auctionLots != undefined) {
          let index: number = 0;
          auctionLots.forEach(lot => {
            // console.log('setAttributeToLots: ' + lot.isClosed);
            if (
              lot.idOrganization != undefined &&
              lot.idOrganization == this.localUtil.authParams.organization_detail.id.toString()
            ) {
              lot.isWinning = true;
            }

            if (!lot.isWinning && lot.userId == this.localUtil.authParams.user_detail.id) {
              lot.isWinning = true;
            }

            if (this.auctionDetail.dataOraFineAsta != lot.dataOraFineAstaEffettiva) {
              lot.isExtratime = true;
              const lotTimer = this.getTimerByName(lot.codiceLotto);
              if (lotTimer != undefined) {
                lotTimer.dateEndCountdown = this.getDataFineAstaEffettiva(lot.dataOraFineAstaEffettiva);
                lotTimer.hourEndCountdown = this.getOraFineAstaEffettiva(lot.dataOraFineAstaEffettiva);
              }
            }

            lot.isClosed = this.getClosedStatus(lot.dataOraFineAstaEffettiva, serverTime);
            // console.log(lot.codiceLotto + ' isClosed: ' + lot.isClosed);
            index++;
          });
        }
      } catch (error) {
        console.error('Error in setAttributeToLots:', error);
      }
    }, 0);
  }

  disableItemRule2(auctionLots: AuctionLotItem[]) {
    setTimeout(() => {
      if (auctionLots) {
        auctionLots.forEach((item: any) => {
          try {
            if (this.auctionDetail.tipologiaAsta == ConstantsModule.TIPOLOGIA_ASTA_DEFAULT) {
              if (this.localUtil.capData == undefined) {
                console.log('capData is null');
              } else {
                if ((this.localUtil.CapData.rule1.residualEligibility + this.localUtil.CapData.rule1.ruleEligibility - this.localUtil.CapData.rule1.winning) < item.quantitaTon) {
                  item.isDisabled = true;
                } else if ((this.localUtil.CapData.rule2.ruleEligibility - this.localUtil.CapData.rule2.winning) < item.quantitaTon) {
                  item.isDisabled = true;
                }

                if ((item.userId != this.localUtil.authParams.user_detail.id) && (item.idOrganization != this.localUtil.authParams.organization_detail.id)) {
                  this.localUtil.CapData.rule3.forEach(function (matRule) {
                    if (matRule.typeMaterial == item.tipoProdotto) {
                      if ((matRule.ruleEligibility - matRule.winning) < item.quantitaTon) {
                        item.isDisabled = true;
                      }
                    }
                  });
                }
              }
            }

          } catch (err) {
            console.log(err);
          }
        });
      }
    }, 0);
  }

  loadFavouriteLots(auctionLots: AuctionLotItem[], beautify: boolean) {
    setTimeout(() => {
      try {
        const lotsFavService = this.auctionService.listFavouriteLots(this.codiceAsta).subscribe(
          (res: GetAuctionLotUserFavouriteResponse) => {
            try {
              if (res && res.list) {
                this.favouriteLots = res.list;
                this.updateFavouriteLots(auctionLots, beautify);
              }
            } catch (innerError) {
              console.error('Error processing favourite lots response:', innerError);
            }
          },
          (error) => {
            console.error('Error in listFavouriteLots service:', error);
            this.handleError(true)(error);
          }
        );
        this.subscriptions.push(lotsFavService);
      } catch (error) {
        console.error('Error in loadFavouriteLots:', error);
      }
    }, 0);
  }


  getBetSlotList(tipologiaAsta: string) {
    setTimeout(() => {
      try {
        if (this.bet_list == undefined || this.bet_list.length == 0) {
          const auctionBetTipologySetupService = this.auctionService.getAuctionBetSetupByTipology(tipologiaAsta).subscribe(
            (data) => {
              this.bet_list = data.list;
              this.minimumBetSlot = this.bet_list[0].taglioRilancio;
            }, this.handleError(true));
          this.subscriptions.push(auctionBetTipologySetupService);
        }
      } catch (err) {
        console.log(err);
      }
    }, 0);
  }

  updateFavouriteLots(auctionLots: AuctionLotItem[], beautifySelect: boolean) {
    try {
      if (auctionLots && this.favouriteLots) {
        auctionLots.forEach(lot => {
          lot.favourite = false;
          this.favouriteLots.forEach(favLot => {
            if (favLot.lotCode == lot.codiceLotto) {
              lot.favourite = true;
            }
          });
        });
        this.auctionLots = [...auctionLots];
        this.filterByText();
  
      } else {
        this.auctionLots = [...this.auctionLotsFull];
        this.filterByText();
      }
    } catch (err) {
      console.error("Error in updateFavouriteLots:", err);
    }
  }  

  sortByFavourite(list: AuctionLotItem[]): AuctionLotItem[] {
    try {
      return list.slice().sort((a, b) => {
        if (a.favourite === b.favourite) return 0;
        return a.favourite ? -1 : 1;
      });
    } catch (error) {
      console.error('Error in sortByFavourite:', error);
      return list; // return original list in case of error
    }
  }

  loadAuctionConfiguration() {
    if (this.codiceAsta != undefined) {
      try {
        const auctionUserSetupService = this.organizationService.getAuctionUserSetup(this.codiceAsta).subscribe(
          (res: any) => {
            try {
              if (res.list != undefined) {
                this.auction_configuration = res.list;

                res.list.forEach((auctionConfig: AuctionSetupItem) => {
                  if (auctionConfig.active) {
                    this.auction_configuration = auctionConfig;
                  }
                });

                this.isTaglioRilancioLibero =
                  this.getAuctionPropValue(ConstantsModule.AUC_TAGLIO_RILANCIO_KEY) === ConstantsModule.AUC_TAGLIO_RILANCIO_LIBERO;

                this.enabledDdlStyle =
                  this.getAuctionPropValue(ConstantsModule.AUC_ENABLE_STYLE_TO_DDL_KEY) === ConstantsModule.AUC_ENABLED_STYLE_TO_DDL;

                this.setRefreshTimerStr(
                  this.refreshLotMillis !== undefined ? this.refreshLotMillis : ConstantsModule.AUC_REFRESH_LOT_MILLIS.toString()
                );

                this.loadRefreshTimer();
              }
            } catch (innerError) {
              console.error('Error processing auction configuration response:', innerError);
            }
          },
          (error) => {
            console.error('Error in getAuctionUserSetup service:', error);
            this.handleError(true)(error);
          }
        );

        this.subscriptions.push(auctionUserSetupService);
      } catch (error) {
        console.error('Error in loadAuctionConfiguration:', error);
      }
    }
  }

  getAuctionPropValue(key: string) {
    let output = '';
    try {
      if (
        this.auction_configuration &&
        key != undefined &&
        key !== '' &&
        this.auction_configuration.properties != undefined
      ) {
        this.auction_configuration.properties.forEach(config => {
          if (config.code === key) {
            output = config.value;
          }
        });
      }
    } catch (error) {
      console.error('Error in getAuctionPropValue:', error);
    }
    return output;
  }

  setRefreshTimerStr(seconds: string) {
    try {
      this.secondsToRefresh = parseInt(seconds);
    } catch (err) {
      this.secondsToRefresh = ConstantsModule.AUC_REFRESH_LOT_MILLIS;
    }
  }

  setRefreshTimer(seconds: number) {
    this.secondsToRefresh = seconds;
  }

  setSliderValues(sliderValue: SliderValue) {
    this.localUtil.setValueSliderCompanySubHeader(sliderValue);
  }

  temporaryDisable(lot: AuctionLotItem) {
    return lot.tempDisable;
  }

  makeOffer(codiceLotto: string, prezzoUltimoRilancio: number, lot: AuctionLotItem) {
    try {
      let taglioRilancio: number = this.betSlotLotto.get(codiceLotto);
      if (taglioRilancio == undefined) {
        taglioRilancio = this.minimumBetSlot;
      }
  
      let prezzoMioRilancio: number = 0;
      let prezzoPartenza: number = parseInt(prezzoUltimoRilancio.toString());
      if (prezzoPartenza == 0) {
        prezzoPartenza = lot.prezzoBase;
      }
  
      if (!this.isTaglioRilancioLibero) {
        prezzoMioRilancio = prezzoPartenza + parseInt(taglioRilancio.toString());
      } else {
        if (lot.bindModel != undefined) {
          prezzoMioRilancio = prezzoPartenza + parseInt(lot.bindModel.toString());
        } else {
          this.localUtil.showMessage("", ConstantsModule.INFO_TITLE, this.messageService.getMessageFromCode("BET_SLOT_MANDATORY"), true);
          return;
        }
      }
  
      let params: any[] = [prezzoMioRilancio, codiceLotto];
  
      (document.activeElement as HTMLElement)?.blur();
      const modalRef = this.modalService.open(ConfirmComponent);
      modalRef.componentInstance.titolo = this.messageService.getLabelFromCode("INFO_TITLE");
      modalRef.componentInstance.messaggio = this.checkAndReplaceTranslation(this.translate, this.messageService.getLabelFromCode("MAKE_OFFER_CONFIRM", params));
      const modalRefService = modalRef.componentInstance.passEntry.subscribe((receivedEntry: any) => {
        if (receivedEntry != undefined) {
          this.tempDisableBetButton(lot);
          const makeOfferService = this.auctionService.makeOffer(this.codiceAsta, codiceLotto, prezzoUltimoRilancio, prezzoMioRilancio).subscribe(
            res => {
              this.getAuctionDetailWithLots('makeoffer', true);
            }, this.handleError(true, () => this.getAuctionDetailWithLots('makeoffer'))
          );
          this.subscriptions.push(makeOfferService);
        }
      }, this.handleError(true));
  
      this.subscriptions.push(modalRefService);
  
    } catch (err) {
      console.error("Error in makeOffer:", err);
    }
  }  

  tempDisableBetButton(lot: AuctionLotItem) {
    if (lot) {
      lot.tempDisable = true;
    }
  }

  loadRules() {
    try {
      if (this.codiceAsta !== undefined) {
        const auctionRulesService = this.auctionService.getAuctionRules(this.codiceAsta).subscribe(
          capData => {
            try {
              this.localUtil.CapData = capData;

              // Barra totale impianto
              let barValues: SliderValue = new SliderValue();
              barValues.type = ConstantsModule.SLIDER_TYPE_CAPACITY;

              barValues.curValue = this.localUtil.CapData.rule2.winning;
              barValues.resValue = (this.localUtil.CapData.rule2.ruleEligibility - this.localUtil.CapData.rule2.winning);
              barValues.maxValue = this.localUtil.CapData.rule2.ruleEligibility;
              barValues.curPerc = (100 * barValues.curValue / barValues.maxValue);
              this.setSliderValues(barValues);

              // rule3 per tipoProdotto
              this.localUtil.CapData.rule3.forEach((matRule: MatRule) => {
                try {
                  barValues = new SliderValue();
                  barValues.type = matRule.typeMaterial;
                  barValues.curValue = matRule.winning;
                  barValues.resValue = (matRule.ruleEligibility - matRule.winning);
                  barValues.maxValue = matRule.ruleEligibility;
                  barValues.curPerc = (100 * barValues.curValue / barValues.maxValue);
                  this.setSliderValues(barValues);
                } catch (innerError) {
                  console.error('Error processing rule3 material rule:', innerError);
                }
              });

              this.localUtil.setCurrentCost(this.localUtil.numberWithCommas(capData.rule1.cost));
            } catch (innerError) {
              console.error('Error processing auction rules:', innerError);
            }
          },
          this.handleError(true)
        );
        this.subscriptions.push(auctionRulesService);
      }
    } catch (error) {
      console.error('Error in loadRules:', error);
    }
  }

  filterByFavourite(favourite: boolean) {
    try {
      let lots: AuctionLotItem[] = [];
      if (favourite != undefined) {
        lots = this.auctionLotsFull;
      } else {
        lots = this.auctionLots;
      }
      let auctionLotFiltered: AuctionLotItem[] = [];
      lots.forEach((lot: AuctionLotItem) => {
        if (this.toggleFilterFavourite) {
          if (lot.favourite) {
            auctionLotFiltered.push(lot);
          }
        } else {
          auctionLotFiltered.push(lot);
        }
      });
      this.auctionLots = [...auctionLotFiltered];
      if (favourite) {
        this.filterByText();
      }
    } catch (err) {
      console.error("Error in filterByFavourite:", err);
    }
  }  

  filterByMaterial(materialItem: MaterialTypeItem) {
    try {
      let lots: AuctionLotItem[] = [];
      if (materialItem) {
        this.setMaterialFilterValue(materialItem);
        lots = this.auctionLotsFull;
      } else {
        lots = this.auctionLots;
      }
      let auctionLotFiltered: AuctionLotItem[] = [];
      lots.forEach((lot: AuctionLotItem) => {
        let addItem: boolean = true;
        this.material_list.forEach((material: MaterialTypeItem) => {
          if (!material.checked && addItem) { //check non selezionato
            if (lot.tipoProdotto == material.type_material) {
              addItem = false;
            }
          }
        });
        if (addItem) {
          auctionLotFiltered.push(lot);
        }
      });
      this.auctionLots = [...auctionLotFiltered];
      if (materialItem) {
        this.filterByFavourite(undefined);
        this.filterByArea(undefined);
      }
    } catch (err) {
      console.error("Error in filterByMaterial:", err);
    }
  }  

  filterForEnabledMaterials(materialList: MaterialTypeItem[]) {
    try {
      let output: MaterialTypeItem[] = [];

      if (materialList && materialList.length > 0) {
        for (const material of materialList) {
          try {
            if (this.enabled_materials.includes(material.type_material)) {
              output.push(material);
            }
          } catch (innerError) {
            console.error('Error processing material in filterForEnabledMaterials:', innerError);
          }
        }
      }

      return output;
    } catch (error) {
      console.error('Error in filterForEnabledMaterials:', error);
      return [];
    }
  }

  setMaterialFilterValue(materialItem: MaterialTypeItem) {
    this.material_list.forEach((material: MaterialTypeItem) => {
      if (materialItem.id == material.id) {
        material.checked = !material.checked;
      }
    });
  }

  filterByArea(areaGeoItem: AreaGeograficaItem) {
    try {
      let lots: AuctionLotItem[] = [];
      if (areaGeoItem) {
        this.setAreaFilterValue(areaGeoItem);
        lots = this.auctionLotsFull;
      } else {
        lots = this.auctionLots;
      }

      let auctionLotFiltered: AuctionLotItem[] = [];
      lots.forEach((lot: AuctionLotItem) => {
        try {
          let addItem: boolean = true;
          this.area_list.forEach((area: AreaGeograficaItem) => {
            try {
              if (!area.checked && addItem) {
                if (lot.areaGeografica === area.area) {
                  addItem = false;
                }
              }
            } catch (innerAreaError) {
              console.error('Error processing area item in filterByArea:', innerAreaError, area);
            }
          });

          if (addItem) {
            auctionLotFiltered.push(lot);
          }
        } catch (innerLotError) {
          console.error('Error processing lot in filterByArea:', innerLotError, lot);
        }
      });

      this.auctionLots = auctionLotFiltered;

      if (areaGeoItem) {
        this.filterByFavourite(undefined);
        this.filterByMaterial(undefined);
      }

    } catch (error) {
      console.error('Error in filterByArea:', error, areaGeoItem);
    }
  }

  setAreaFilterValue(areaGeoItem: AreaGeograficaItem) {
    try {
      this.area_list.forEach((area: AreaGeograficaItem) => {
        try {
          if (areaGeoItem.id === area.id) {
            area.checked = !area.checked;
          }
        } catch (innerError) {
          console.error('Error toggling checked state in setAreaFilterValue:', innerError, area);
        }
      });
    } catch (error) {
      console.error('Error in setAreaFilterValue:', error, areaGeoItem);
    }
  }

  addFavouriteLot(codiceLotto: string) {
    try {
      if (codiceLotto) {
        const addFavLotService = this.auctionService.addFavouriteLot(this.codiceAsta, codiceLotto).subscribe(
          (res) => {
            try {
              this.loadFavouriteLots(this.auctionLots, false);
            } catch (innerError) {
              console.error('Error inside success callback of addFavouriteLot:', innerError, this.auctionLots);
            }
          },
          this.handleError(true)
        );
        this.subscriptions.push(addFavLotService);
      }
    } catch (error) {
      console.error('Error in addFavouriteLot:', error, codiceLotto);
    }
  }

  removeFavouriteLot(codiceLotto: string) {
    try {
      if (codiceLotto) {
        const removeFavLotService = this.auctionService.removeFavouriteLot(this.codiceAsta, codiceLotto).subscribe(
          (res) => {
            try {
              this.loadFavouriteLots(this.auctionLots, false);
            } catch (innerError) {
              console.error('Error inside success callback of removeFavouriteLot:', innerError, this.auctionLots);
            }
          },
          this.handleError(true)
        );
        this.subscriptions.push(removeFavLotService);
      }
    } catch (error) {
      console.error('Error in removeFavouriteLot:', error, codiceLotto);
    }
  }

  getDefaultTaglioRilancio() {
    let output = '';
    try {
      if (this.bet_list != undefined && this.bet_list.length > 0) {
        output = this.bet_list[0].taglioRilancio.toString();
      }
      return output;
    } catch (err) {
      console.log(err);
    }
    return output;
  }

  changeBetSlot(e, codiceLotto: string) {
    try {
      let betVal: number = 0;
      if (this.enabledDdlStyle) {
        betVal = e.itemData.taglioRilancio;
        this.betSlotLotto.set(codiceLotto, betVal);
      } else {
        let betVal = e.target.value;
        setTimeout(() => {
          this.betSlotLotto.set(codiceLotto, betVal);
        });
      }
    } catch (err) {
      console.log(err);
    }
  }

  private refreshTimerId: any;

  loadRefreshTimer() {
    try {
      if (this.codiceAsta !== undefined && (this.localUtil.isListView() || this.localUtil.isBoxView())) {
        // Se esiste già un timer, lo cancello per evitare duplicazioni
        if (this.refreshTimerId) {
          clearTimeout(this.refreshTimerId);
        }

        this.refreshTimerId = setTimeout(() => {
          try {
            this.manageRefreshTimer();
            this.loadRefreshTimer();
          } catch (innerError) {
            console.error('Error inside refreshTimer callback:', innerError, this.codiceAsta);
          }
        }, 1000);
      }
    } catch (error) {
      console.error('Error in loadRefreshTimer:', error, this.codiceAsta);
    }
  }

  manageRefreshTimer() {
    try {
      this.secondsToRefresh = this.secondsToRefresh - 1000;
      this.cdRef.detectChanges();
      
      if (this.secondsToRefresh == 0) {
        if (ConstantsModule.REFRESH_LOTS_ENABLED) {
          this.getAuctionDetailWithLots('manageRefreshTimer');
        }
        this.setRefreshTimerStr(this.refreshLotMillis != undefined ? this.refreshLotMillis : ConstantsModule.AUC_REFRESH_LOT_MILLIS.toString());
      }
    } catch (err) {
      console.error("Error in manageRefreshTimer:", err);
    }
  }  

  increaseFont() {
    try {
      let style: any = document.body.style;
      let actualZoom: any = style.zoom;
  
      if (actualZoom == undefined || actualZoom == "") actualZoom = "100%";
  
      actualZoom = actualZoom.substr(0, actualZoom.length - 1);
      actualZoom = parseInt(actualZoom) + 5;
  
      if (actualZoom > 0) {
        style.zoom = actualZoom + "%";
      }
    } catch (err) {
      console.error("Error in increaseFont:", err);
    }
  }  

  decreaseFont() {
    try {
      let style: any = document.body.style;
      let actualZoom: any = style.zoom;
  
      if (actualZoom == undefined || actualZoom == "") actualZoom = "100%";
  
      actualZoom = actualZoom.substr(0, actualZoom.length - 1);
      actualZoom = parseInt(actualZoom) - 5;
  
      if (actualZoom > 0) {
        style.zoom = actualZoom + "%";
      }
    } catch (err) {
      console.error("Error in decreaseFont:", err);
    }
  }  

  enableReloadButton() {
    if (!this.reloadEnabled) {
      //console.log('enabling reload button');
      this.reloadEnabled = true;
    }
  }

  getDisabledReloadLots() {
    return this.reloadEnabled ? '' : 'disabled';
  }

  getValueByCodiceLotto(codiceLotto) {
    try {
      return this.betSlotLotto.get(codiceLotto) != undefined ? this.betSlotLotto.get(codiceLotto) : this.bet_list[0].taglioRilancio;
    } catch (err) {
      return '';
    }
  }

  formatBet(bet: any): string {
    try {
      return `+${bet?.taglioRilancio} €`;
    } catch (err) {
      return `+0 €`;
    }
  }

  onToolbarPreparing(e) {
    e.toolbarOptions.items.unshift({
      location: "after",
      template: "favouritesFilterButton"
    });
  }

  filterFavouriteLots(e) {
    this.toggleFilterFavourite = !this.toggleFilterFavourite;
    this.filterByFavourite(this.toggleFilterFavourite);
    this.localUtil.setSessionProp('fav_filter', this.toggleFilterFavourite);
  }

  loadAreaGeo() {
    try {
      const geoAreaService = this.commonService.getAreaGeograficaList().subscribe(
        data => {
          this.area_list = data.list;
          this.area_list.forEach((area: AreaGeograficaItem) => {
            area.checked = true;
          });
        },
        this.handleError(true)
      );

      this.subscriptions.push(geoAreaService);
    } catch (err) {
      console.error('Synchronous error in loadAreaGeo:', err);
    }
  }

  loadMaterialType() {
    const materialTypeService = this.commonService.getMaterialTypesList().subscribe(
      data => {
        try {
          const auctionType = this.auctionDetail != undefined
            ? this.auctionDetail.tipologiaAsta
            : ConstantsModule.TIPOLOGIA_ASTA_DEFAULT;

          const filteredMaterials = this.localUtil.filterTipoProdottoWithExclusion(data.list, auctionType);
          this.material_list = this.filterForEnabledMaterials(filteredMaterials);

          this.material_list.forEach((material: MaterialTypeItem) => {
            material.checked = true;
          });
        } catch (error) {
          console.error('Error processing material types:', error);
        }
      },
      this.handleError(true)
    );
    this.subscriptions.push(materialTypeService);
  }

  loadSchedaTecnicaList() {
    try {
      let scheda: SchedaTecnicaItem = new SchedaTecnicaItem();
      scheda.document = 'scheda-tecnica-PET-Azzurrato.pdf';
      this.scheda_list.push(scheda);

      scheda = new SchedaTecnicaItem();
      scheda.document = 'scheda-tecnica-PET-Colorato.pdf';
      this.scheda_list.push(scheda);

      scheda = new SchedaTecnicaItem();
      scheda.document = 'scheda-tecnica-PET-Trasparente.pdf';
      this.scheda_list.push(scheda);

      scheda = new SchedaTecnicaItem();
      scheda.document = 'scheda-tecnica-PET-Misto.pdf';
      this.scheda_list.push(scheda);
    } catch (error) {
      console.error('Error while loading scheda tecnica list:', error);
    }
  }

  getColorePET(tipoProdotto: any) {
    let output = '';
    try {
      if (tipoProdotto != undefined) {
        if (tipoProdotto == ConstantsModule.PET_COLORATO) {
          output = ConstantsModule.PET_CSS_COLORATO;
        } else if (tipoProdotto == ConstantsModule.PET_AZZURRATO) {
          output = ConstantsModule.PET_CSS_AZZURRATO;
        } else if (tipoProdotto == ConstantsModule.PET_TRASPARENTE) {
          output = ConstantsModule.PET_CSS_TRASPARENTE;
        } else if (tipoProdotto == ConstantsModule.PET_MISTO) {
          output = ConstantsModule.PET_CSS_MISTO;
        }
      }
    } catch (error) {
      console.error('Error in getColorePET:', error);
    }
    return output;
  }

  timerEventRaised(outputTimerEmit: AuctionLotTimerItem) {
    this.updateLotStatus(outputTimerEmit);
  }

  updateLotStatus(outputTimerEmit: AuctionLotTimerItem) {
    try {
      setTimeout(() => {
        try {
          if (this.auctionLots != undefined && outputTimerEmit != undefined) {
            this.auctionLots.forEach(lot => {
              if (lot.codiceLotto == outputTimerEmit.codiceLotto) {
                lot.isClosed = outputTimerEmit.isClosed;
                lot.isExtratime = outputTimerEmit.isExtratime;
              }
            });
          }
        } catch (innerError) {
          console.error('Error inside setTimeout in updateLotStatus:', innerError);
        }
      }, 0);
    } catch (error) {
      console.error('Error in updateLotStatus:', error);
    }
  }

  filterByText() {
    try {
      if (this.searchLotText) {
        let auctionLotFiltered: AuctionLotItem[] = [];
        this.auctionLotsFull.forEach((lot: AuctionLotItem) => {
          if (JSON.stringify(lot).toLowerCase().indexOf(this.searchLotText.toLowerCase()) > -1) {
            auctionLotFiltered.push(lot);
          }
        });
        this.auctionLots = [...auctionLotFiltered];
      } else {
        this.auctionLots = [...this.auctionLotsFull];
      }
      this.filterByFavourite(undefined);
      this.filterByMaterial(undefined);
      this.filterByArea(undefined);
    } catch (err) {
      console.error("Error in filterByText:", err);
    }
  }  

  @HostListener('window:resize', ['$event']) onResize() {
    this.manageStickyHeader();
  }

  @HostListener('window:scroll', ['$event']) onScroll() {
    this.manageStickyHeader();
  }

  manageStickyHeader() {
    try {
      const cardsLotsList = document.getElementById("cards-lots-list");
      if (!cardsLotsList) {
        return;
      }

      const sticky = cardsLotsList.offsetTop;
      const tableHeader = document.getElementById("cards-lots-list-header") as HTMLElement;

      const scrollPosition = window.pageYOffset;
      const offset_var = 145;

      if (scrollPosition + offset_var > sticky) {
        this.navbarfixed = true;
        this.headerDetail.stickyHeader = true;
        this.localUtil.setHeaderMonitor(this.headerDetail);
        if (this.codiceAsta) {
          this.localUtil.showHeaderSticky(
            this.isAstaSingola()
              ? ConstantsModule.AUC_MOTORE_ASTA_SINGOLA
              : ConstantsModule.AUC_MOTORE_ASTA_MULTIPLA
          );
        }
      } else {
        this.navbarfixed = false;
        this.headerDetail.stickyHeader = false;
        this.localUtil.setHeaderMonitor(this.headerDetail);
        if (this.codiceAsta) {
          this.localUtil.hideHeaderSticky(
            this.isAstaSingola()
              ? ConstantsModule.AUC_MOTORE_ASTA_SINGOLA
              : ConstantsModule.AUC_MOTORE_ASTA_MULTIPLA
          );
        }
      }

      this.cdRef.detectChanges();
      this.setHeaderSticky();

      if (tableHeader && window.innerWidth < 1200) {
        tableHeader.style.marginTop = `-13px`;
      } else if (tableHeader) {
        tableHeader.style.marginTop = `1px`;
      }
    } catch (error) {
      console.error('Error in manageStickyHeader:', error);
    }
  }

  isAstaSingola() {
    try {
      if (this.auction_configuration) {
        return this.auction_configuration.motore === ConstantsModule.AUC_MOTORE_ASTA_SINGOLA;
      } else {
        return false;
      }
    } catch (error) {
      console.error('Error in isAstaSingola:', error);
      return false;
    }
  }

  setHeaderSticky() {
    if (this.codiceAsta != undefined) {
      try {
        $('#lotto').width($('#lottoHeader').width());
        $('#tipologia').width($('#tipologiaHeader').width());
        $('#area').width($('#areaHeader').width());
        $('#quantita').width($('#quantitaHeader').width());
        $('#rilanci').width($('#rilanciHeader').width());
        $('#prezzo').width($('#prezzoHeader').width());
        $('#tempo').width($('#tempoHeader').width());
        $('#stato').width($('#statoHeader').width());
        $('#azione1').width($('#azione1Header').width());
        $('#azione2').width($('#azione2Header').width());

        if ($("#container").hasClass("sidebar_closed")) {
          $('header.fixed-header').addClass('full');
          $('.overview-tool.fixed-parameters').addClass('full');
          //$('#cards-lots-list-header').css('margin-left', $('#cards-lots-list').offset().left - 10 + 'px');
        } else {
          $('header.fixed-header').removeClass('full');
          $('.overview-tool.fixed-parameters').removeClass('full');
          //$('.timerHeader').addClass('full');
        }
      } catch (err) {
        //
      }
    }
  }

  lotDetail(lot: AuctionLotItem) {
    try {
      let lotDetailElem: AuctionLotItem = lot;
      let csLots: CentroSelezioneItem[] = [];
      const modalRef = this.modalService.open(PopupComponent);
      modalRef.componentInstance.tipo = 'openLotDetail';
      modalRef.componentInstance.codiceLotto = lot.codiceLotto;
      modalRef.componentInstance.isFavourite = lot.favourite;
      let isCsLoaded: boolean = false;
      let isLotDetailLoaded: boolean = false;

      const selectionCenterService = this.commonService.getSelectionCenterList().subscribe(
        (data: GetSelectionCenterListResponse) => {
          let csList = data.list;
          lot.centroSelezione.forEach(csLot => {
            csList.forEach((cs: CentroSelezioneItem) => {
              if (cs.codice == csLot.codiceCentroSelezione) {
                csLot = $.extend(cs, csLot);
                csLots.push(csLot);
              }
            });
            if (isCsLoaded && isLotDetailLoaded && modalRef && modalRef.componentInstance) {
              modalRef.componentInstance.isLoading = false;
            }
          });
        }
      );
      this.subscriptions.push(selectionCenterService);

      const lotDetailService = this.auctionService.getLotDetail(lot.codiceAsta, lot.codiceLotto).subscribe(
        data => {
          lotDetailElem = data.lot;
          lotDetailElem.centroSelezione = csLots;
          const lotsHistoryService = this.auctionService.getAuctionLotsHistory(lot.codiceAsta, lot.id).subscribe(
            res => {
              lotDetailElem.rilanciLotto = res.list;
              lotDetailElem.numContendentiUnici = res.numContendentiUnici;
              if (modalRef && modalRef.componentInstance) {
                modalRef.componentInstance.lot = lotDetailElem;
                if (isCsLoaded && isLotDetailLoaded) {
                  modalRef.componentInstance.isLoading = false;
                }
              }
            }, this.handleError(true)
          );
          this.subscriptions.push(lotsHistoryService);

        }, this.handleError(true)
      );
      this.subscriptions.push(lotDetailService);
    } catch (err) {
      //
    }
  }

  getProdottoClass(tipoProdotto: string) {
    try {
      let output = tipoProdotto;
      if (tipoProdotto != undefined) {
        if (tipoProdotto.indexOf(ConstantsModule.PET_PREFIX) > -1) {
          output = tipoProdotto
            .substring(ConstantsModule.PET_PREFIX.length, tipoProdotto.length)
            .toLocaleLowerCase();
        }
      }
      return output;
    } catch (error) {
      console.error('Error in getProdottoClass:', error);
      return tipoProdotto;
    }
  }

  isEnabledToAuction() {
    return this.localUtil.isEnabledToAuction();
  }

  getTimerByName(name: string): TimerComponent | undefined {
    return this.timerComponents.toArray().find(timer => timer.name === name);
  }

}